/**
 * GSAP conditional loading
 * Only loads GSAP + ScrollTrigger if elements with [data-gsap] exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "../utils/dom-ready";
onDomReady(() => {
    const gsapElements = document.querySelectorAll("[data-gsap]");
    if (gsapElements.length > 0) {
        import("gsap")
            .then(({ gsap }) => {
            return import("gsap/ScrollTrigger").then(({ ScrollTrigger }) => {
                gsap.registerPlugin(ScrollTrigger);
                globalThis.gsap = gsap;
                globalThis.ScrollTrigger = ScrollTrigger;
                const event = new CustomEvent("gsap-loaded", {
                    bubbles: true,
                });
                window.dispatchEvent(event);
            });
        })
            .catch((error) => {
            console.error("Failed to load GSAP:", error);
        });
    }
});
